import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Link} from 'shells/link/link';

export function ErrorState() {
    return (
        <EmptyStateLarge
            icon={
                <img
                    alt=''
                    style={{width: 240}}
                    src='/include/images/empty-states/Error_doodle.svg'
                />
            }
            title='Uh oh!'
            subtitle={
                <div>
                    We ran into an error. Please try again or if the problem persists, please{' '}
                    <Link
                        variant='primary'
                        newTab={true}
                        href='https://support.nutshell.com/'
                        size='big'
                    >
                        contact our friendly support team for help
                    </Link>
                    .
                </div>
            }
        />
    );
}
